import { render, staticRenderFns } from "./JuryScore.vue?vue&type=template&id=1d284423"
import script from "./JuryScore.vue?vue&type=script&lang=js"
export * from "./JuryScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports